import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { cn } from "lib/utils";

interface Props extends React.ComponentProps<typeof Input> {
  label?: string;
  value: string;
  setter: (v: string) => void;
  placeholder?: string;
  mask?: (value: string) => string;
}

const InputWithLabel = ({
  label,
  value,
  setter,
  placeholder,
  mask,
  className,
  ...props
}: Props) => {
  return (
    <div className="flex flex-col text-brand-text">
      <Label htmlFor={label} className="px-1 text-brand-text">
        {label}
      </Label>
      <Input
        id={label}
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          const value = mask ? mask(e.target.value) : e.target.value;
          setter(value);
        }}
        className={cn(
          "bg-background py-[21px] focus-visible:ring-1 focus-visible:ring-brand-primary focus-visible:ring-offset-0",
          className,
        )}
        {...props}
      />
    </div>
  );
};
export default InputWithLabel;
